// Copyright (c) 2015, Lucrumerp Pvt. Ltd. and Contributors
// License: GNU General Public License v3. See license.txt

if(!window.lucrum) window.lucrum = {};

// Add / update a new Lead / Communication
// subject, sender, description
ducky.send_message = function(opts, btn) {
	return ducky.call({
		type: "POST",
		method: "lucrum.templates.utils.send_message",
		btn: btn,
		args: opts,
		callback: opts.callback
	});
};

lucrum.subscribe_to_newsletter = function(opts, btn) {
	return ducky.call({
		type: "POST",
		method: "ducky.email.doctype.newsletter.newsletter.subscribe",
		btn: btn,
		args: {"email": opts.email},
		callback: opts.callback
	});
}

// for backward compatibility
lucrum.send_message = ducky.send_message;
